import {ValidationStepConfig} from 'src/types/form';
import {RegistrationSteps} from 'src/types/enums';
import Eligibility from 'src/components/form/onboarding/eligibility/eligibility';
import {HighSchoolInformationForm} from 'src/types/onboarding';
import validateEligibilityStep from '../../../../../shared/student/registration/validations/validate-eligibility-step';
import onControlledSubmit from 'src/components/form/onboarding/Address/onControlledSubmit';

export default Eligibility;

export const EligibilityStepConfig: ValidationStepConfig<HighSchoolInformationForm, void> = {
  key: RegistrationSteps.ELIGIBILITY,
  Component: Eligibility,
  pathSuffix: 'eligibility',
  // @ts-expect-error
  onControlledSubmit,
  validate: validateEligibilityStep,
};
